import { useEffect, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { FaCircleXmark } from "react-icons/fa6";
import ClipLoader from "react-spinners/ClipLoader";
// import {
//   useAddCategoryMutation,
//   useUpdateCategoryMutation,
// } from "../../Data/services/categoryApi";
import { useUploadAttachmentMutation } from "../../Data/services/uploadAttachmentApi";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import { Button, Input } from "../CustomComponents";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import SelectFieldComponent from "../CustomComponents/SelectFieldComponent";
import _ from "lodash";
// import {
//   useAddQuestionMutation,
//   useUpdateQuestionMutation,
// } from "../../Data/services/questionApi";
// import {
//   useAddActivityMutation,
//   useUpdateActivityMutation,
// } from "../../Data/services/activityApi";
import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../lib/apiClient";
import { activityService } from "../../Services/activityService";

const MAX_OPTIONS = 5;

const EditActivityModal = ({
  handleEditModalClose,
  editData,
  categoryData,
  refetch,
}) => {
  const [rowId, setRowId] = useState("");
  const [name, setName] = useState("");
  // const [description, setDescription] = useState("");
  const [spoon_count, setSpoonCount] = useState("");
  // const [audioUrl, setAudioUrl] = useState("");
  // const [audioFile, setAudioFile] = useState(null);
  // const [audioPreview, setAudioPreview] = useState("");
  // const [options, setOptions] = useState([]);
  // const [sending, setSending] = useState(false);

  const [categoryList, setCategoryList] = useState([]);

  const [selectedType, setSelectedType] = useState("");
  // console.log(selectedType);

  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  useEffect(() => {
    if (editData) {
      console.log(editData);
      setRowId(editData?.id);
      setName(editData?.name || "");
      // setDescription(editData?.spoon_count || "");
      setSpoonCount(editData?.spoon_count || "");
      setSelectedType(editData?.category_id || "");
      // setAudioUrl(editData?.audio_url);
      // setAudioPreview(editData?.audio_url || "");
      // setOptions(
      //   editData?.options.map((opt) => ({
      //     option: opt.option,
      //     is_correct: opt.is_correct,
      //   })) || []
      // );
    }
  }, [editData]);

  // console.log(options);

  useEffect(() => {
    if (categoryData && categoryData.length > 0) {
      setCategoryList(categoryData);
    }
  }, [categoryData]);

  const { mutate: createActivity, isPending: creating } =
    activityService.useCreate();
  const { mutate: updateActivity, isPending: updating } =
    activityService.useUpdatePatch();

  const handleSubmit = async () => {
    if (!name || spoon_count === 0) {
      Toast("Please fill all required fields", "error");
      return;
    }

    const data = {
      name: name,
      spoon_count: spoon_count,
      category_id: selectedType ? Number(selectedType) : null,
    };

    const mutation = editData ? updateActivity : createActivity;
    const mutationBody = editData ? { id: rowId, body: data } : data;

    mutation(mutationBody, {
      onSuccess: (response) => {
        if (response.code === 200) {
          refetch();
          SuccessToast(response?.message);
          handleEditModalClose();
        } else {
          Toast(response.message, "error");
        }
      },
      onError: (error) => {
        if (error?.data && error?.data?.message) {
          Toast(error?.data?.message, "error");
        } else {
          Toast("An error occurred", "error");
        }
        handleEditModalClose();
      },
    });
  };

  if (!mounted) {
    return null;
  }

  return (
    <div>
      <ModalContainer handleClose={handleEditModalClose}>
        <div
          className={cssStyles.modalContainer}
          // style={{ maxWidth: "90vw" }}
        >
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-medium m-0">
              {editData ? "Edit Activity" : "Add Activity"}
            </p>
            <span
              className=""
              onClick={handleEditModalClose}
              style={{ cursor: "pointer" }}
            >
              <FaCircleXmark color="gray" size="35px" />
            </span>
          </div>
          <div className="w-100">
            <Row>
              <Col md={12}>
                <Input
                  classes="mb-3"
                  type="text"
                  placeholder="Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <Input
                  classes="mb-3"
                  type="number"
                  placeholder="Spoon Count"
                  min={0}
                  value={spoon_count}
                  onChange={(e) => setSpoonCount(e.target.value)}
                />
                <SelectFieldComponent
                  optionsList={categoryList}
                  onSelectChange={(value) => setSelectedType(value)}
                  firstOption={selectedType || "Select Category"}
                  value={selectedType}
                />
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <Button
                  classes={`mt-3 mb-2 ${
                    creating || updating || !name ? "bg-dark-subtle" : "shadow"
                  } `}
                  text={
                    creating || updating ? (
                      <ClipLoader color="#000" size="22" />
                    ) : editData ? (
                      "Update"
                    ) : (
                      "Save"
                    )
                  }
                  disabled={creating || updating || !name}
                  onClick={handleSubmit}
                ></Button>
              </Col>
            </Row>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default EditActivityModal;
